import $ from 'jquery';
import get from 'lodash/get';
import config from '../modules/config';

const validate = async (email) => {
  try {
    const response = await $.post(config('ENDPOINTS.EMAIL_VALIDATOR'), {
      email,
    });

    return get(response, 'success') === true;
  } catch (e) {
    console.log(`Unable to validate the e-mail: ${email}`, e);
    return false;
  }
};

window.Parsley.addValidator('asyncEmail', {
  async validateString(email) {
    const valid = await validate(email);

    if (!valid) {
      throw new Error('E-mail validation failed');
    }

    return true;
  },
});
